module.exports = __webpack_public_path__ + "img/10_windAndRain_hc.4b26da91.png";